import { useState, useEffect } from 'react';
import AppRouter from './AppRouter';
import { Toaster } from './components/ui/sonner';
import { ImpersonationProvider } from './components/ImpersonationContext';
import { projectId } from './utils/supabase/info';

// Main application component
export default function App() {
  return (
    <ImpersonationProvider projectId={projectId}>
      <AppRouter />
      {/* One toaster for every view: AppRouter's platform branches (root and staging hosts) rendered none */}
      <Toaster />
    </ImpersonationProvider>
  );
}